<template>
  <div id="cadastrar-contrato" dusk="cadastrar-contrato">
    <contrato-form-placeholder v-if="loading" />
    <template v-else>
      <div class="vx-row">
        <vs-col vs-lg="8" vs-md="6" vs-sm="12">
          <vx-card
            ref="dadosPessoaisCard"
            title="Dados pessoais"
            subtitle="Preencha corretamente os dados pessoais do cliente."
            cardBorder
            noShadow
          >
            <editar-dados-pessoais ref="dadosPessoaisRef" v-model="cliente"></editar-dados-pessoais>
          </vx-card>

          <vx-card
            ref="enderecosCard"
            title="Endereços"
            subtitle="Preencha corretamente o endereço do cliente."
            cardBorder
            noShadow
          >
            <div
              class="editar-endereco-container"
              v-for="(endereco, index) in enderecos"
              v-bind:key="endereco.id"
            >
              <editar-endereco ref="enderecosRef" v-model="enderecos[index]"></editar-endereco>
            </div>
          </vx-card>

          <vx-card
            ref="telefonesCard"
            title="Telefones"
            subtitle="Preencha corretamente o telefone do cliente."
            cardBorder
            noShadow
          >
            <div
              class="editar-telefone-container"
              v-for="(telefone, index) in telefones"
              v-bind:key="telefone.id"
            >
              <editar-telefone ref="telefonesRef" v-model="telefones[index]"></editar-telefone>
            </div>
          </vx-card>
        </vs-col>

        <vs-col vs-lg="4" vs-md="6" vs-sm="12" class="vx-col mb-4">
          <div class="vx-row">
            <!-- Cobrança -->
            <vs-col vs-w="12" class="vx-col mb-6">
              <vx-card ref="descontoCard" title="Cobrança" cardBorder noShadow class="vx-card-blue">
                <editar-cobranca-inss ref="cobrancaInssRef" v-model="desconto"></editar-cobranca-inss>
              </vx-card>
            </vs-col>
            <!-- Cobrança -->
          </div>
        </vs-col>

        <vs-col vs-lg="4" vs-md="6" vs-sm="12" class="vx-col mb-4">
          <div class="vx-row">
            <!-- Salvar contrato -->
            <div class="faixa-white">
              <vs-button
                @click="$router.push('/contratos')"
                type="border"
                color="dark"
                size="large"
                class="btn-float font-bold mr-2"
              >Fechar</vs-button>
              <vs-button
                @click="cadastrarDesconto"
                type="relief"
                size="large"
                class="btn-float font-bold"
              >
                <feather-icon class="align-middle inline-block mr-2" icon="SaveIcon" />Cadastrar Contrato
              </vs-button>
            </div>
            <!-- Salvar contrato -->
          </div>
        </vs-col>
      </div>
    </template>
  </div>
</template>

<script>
import EditarDadosPessoais from "./components/EditarDadosPessoais.vue";
import EditarEndereco from "./components/EditarEndereco.vue";
import EditarTelefone from "./components/EditarTelefone.vue";
import EditarCobrancaInss from "./components/EditarCobrancaInss.vue";
import ContratoFormPlaceholder from "@/components/placeholders/ContratoFormPlaceholder";
import api from "@services/api-service";
import queryParams from "@services/repository-service";
import { setTimeout } from "timers";

export default {
  components: {
    EditarDadosPessoais,
    ContratoFormPlaceholder,
    EditarEndereco,
    EditarTelefone,
    EditarCobrancaInss
  },
  provide() {
    return {
      $validator: this.$validator
    };
  },
  data() {
    return {
      desconto: {
        beneficio: {}
      },
      cliente: {},
      enderecos: [{}],
      telefones: [{}],
      loading: false
    };
  },
  created() {
    if (this.$route.query.__dusk__) {
      this.$route.params.cpf = this.$route.query.cpf;
      this.$route.params.beneficio = this.$route.query.beneficio;
      this.$route.params.associacao = this.$store.getters.getUsuarioAssociacao();
    }

    if (!this.$route.params.cpf || !this.$route.params.beneficio) {
      this.alertaErro(
        "Para cadastrar um desconto, verifique se o benefício já existe"
      );
      return this.$router.replace({ name: "contratos" });
    }

    if (!this.$route.params.associacao) {
      this.alertaErro("Dados da associação não encontrado.");
      return this.$router.replace({ name: "contratos" });
    }

    this.cliente.cpf = this.$route.params.cpf;
    this.desconto.beneficio.beneficio = this.$route.params.beneficio;
    this.desconto.tipoContrato = this.$route.params.tipoContrato;
    this.desconto.formaPagamento = this.$route.params.formaPagamento;
    this.desconto.associacao = this.$route.params.associacao;
    this.desconto.entidade = this.$store.getters.getUsuarioEntidade();
    this.desconto.parceiro = this.$store.getters.getUsuarioParceiro();
    this.desconto.usuario_id = this.$store.getters.getUsuarioId();
    this.desconto.auxilio_funeral = false;
    this.desconto.desconto_13 = false;
  },
  mounted() {
    this.loading = true;
    setTimeout(async () => {
      await this.buscarClientePorCpf();
      this.loading = false;
    }, 100);
  },
  methods: {
    async buscarClientePorCpf() {
      try {
        const response = await api().get(`clientes`, {
          params: {
            cpf: this.cliente.cpf,
            ...queryParams({
              relationships: [
                "sexo",
                "estadoCivil",
                "enderecos",
                "enderecos.cidade",
                "enderecos.estado",
                "telefones",
                "beneficios",
                "beneficios.especieBeneficio"
              ],
              where: [
                ["beneficios.beneficio", "=", this.desconto.beneficio.beneficio]
              ]
            })
          }
        });

        if (response.data.status) {
          this.cliente = response.data.data;

          if (this.cliente.enderecos.length > 0) {
            this.enderecos = this.cliente.enderecos;
          }

          if (this.cliente.telefones.length > 0) {
            this.telefones = this.cliente.telefones;
          }

          this.cliente.beneficios
            .filter(b => b.beneficio == this.desconto.beneficio.beneficio)
            .map(b => (this.desconto = { ...this.desconto, beneficio: b }));
        }
      } catch (error) {
        //
      }
    },
    async cadastrarDesconto() {
      try {
        await this.validarFormulario();

        this.loading = true;

        // SALVAR CLIENTE
        let clienteResponse = {};
        if (this.cliente.id) {
          clienteResponse = await api().put(
            `clientes/${this.cliente.id}`,
            this.cliente
          );
        } else {
          clienteResponse = await api().post(`clientes`, this.cliente);
        }
        if (!clienteResponse.data.status)
          throw Error("Ocorreu um erro ao cadastrar o cliente.");
        this.cliente.id = clienteResponse.data.data.id;

        // SALVAR ENDERECOS
        this.enderecos.map(async endereco => {
          endereco.cliente_id = this.cliente.id;
          let enderecoResponse = {};

          if (endereco.id) {
            enderecoResponse = await api().put(
              `cliente-endereco/${endereco.id}`,
              endereco
            );
          } else {
            enderecoResponse = await api().post(`cliente-endereco`, endereco);
          }

          if (!enderecoResponse.data.status)
            throw Error("Ocorreu um erro ao cadastrar o endereço do cliente.");
        });

        // SALVAR TELEFONES
        this.telefones.map(async telefone => {
          telefone.cliente_id = this.cliente.id;
          let telefoneResponse = {};

          if (telefone.id) {
            telefoneResponse = await api().put(
              `cliente-telefone/${telefone.id}`,
              telefone
            );
          } else {
            telefoneResponse = await api().post(`cliente-telefone`, telefone);
          }

          if (!telefoneResponse.data.status)
            throw Error("Ocorreu um erro ao cadastrar o telefone do cliente.");
        });

        // SALVAR BENEFICIO
        let beneficioResponse = {};
        this.desconto.beneficio.cliente_id = this.cliente.id;
        if (this.desconto.beneficio.id) {
          beneficioResponse = await api().put(
            `beneficios/${this.desconto.beneficio.id}`,
            this.desconto.beneficio
          );
        } else {
          beneficioResponse = await api().post(
            `beneficios`,
            this.desconto.beneficio
          );
        }
        if (!beneficioResponse.data.status) {
          throw Error("Ocorreu um erro ao cadastrar o benefício do cliente.");
        }

        this.desconto = {
          ...this.desconto,
          beneficio_id: beneficioResponse.data.data.id,
          beneficio: {
            ...this.desconto.beneficio,
            id: beneficioResponse.data.data.id
          }
        };

        // SALVAR DESCONTO
        this.desconto.cliente_id = this.cliente.id;
        const descontoResponse = await api().post(`contratos`, this.desconto);
        if (!descontoResponse.data.status)
          throw Error("Ocorreu um erro ao cadastrar o desconto.");

        this.alertaSucesso("Contrato cadastrado com sucesso.");

        this.$router.push({
          name: "gerenciar-contrato",
          params: { id: descontoResponse.data.data.id }
        });
      } catch (error) {
        this.alertaErro(error.message);
        this.loading = false;
      }
    },
    validarFormulario() {
      const formularios = [
        this.$refs.dadosPessoaisRef,
        ...this.$refs.enderecosRef,
        ...this.$refs.telefonesRef,
        this.$refs.cobrancaInssRef
      ];

      return Promise.all(
        formularios.map(async function(child) {
          const valido = await child.$validator.validateAll();
          if (!valido) {
            switch (child.$options.name) {
              case "editar-dados-pessoais":
                throw Error("Complete os dados pessoais do cliente.");
              case "editar-endereco":
                throw Error("Complete o endereço do cliente.");
              case "editar-cobranca-inss":
                throw Error("Complete os dados de cobrança.");
              default:
                throw Error();
            }
          }
        })
      );
    },
    alertaSucesso(text) {
      this.$vs.notify({
        title: "Sucesso!",
        text: text,
        color: "success",
        iconPack: "feather",
        icon: "icon-check",
        position: "bottom-center"
      });
    },
    alertaErro(text) {
      this.$vs.notify({
        title: "Erro.",
        text: text,
        color: "danger",
        iconPack: "feather",
        icon: "icon-alert-circle",
        position: "bottom-center",
        time: 10000
      });
    }
  }
};
</script>



